import React, { Component } from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import { storageKeys, trainingSplit } from 'settings';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  APIHandler,
  DataHandler,
  Diploma,
  StorageHandler,
  TrainingGrid,
  ContentHeader,
  Progress,
  BackButton,
  TrainingNav,
} from 'C4';

const getTotalPages = (res) => {
  let totalPages = 0;
  if (res) {
    const { chapters } = res.data[0];
    let i = 0;
    for (i = 0; i < trainingSplit.foundation - 1; i++) {
      totalPages += chapters[i].total_pages;
    }
  }
  return totalPages;
};

// Makes sure progress is returned in percentage value
const calculateProgress = (progress, pages) =>
  Math.floor((progress / pages) * 100);

const getTotalProgress = (res) => {
  let totalProgress = 0;
  if (res) {
    const { chapters } = res.data[0];
    let i = 0;
    for (i = 0; i < trainingSplit.foundation - 1; i++) {
      totalProgress += chapters[i].progress;
    }
  }
  return totalProgress;
};

const ViewDiploma = ({ diploma }) => {
  if (diploma !== 100) return null;

  const hasViewedDiploma = localStorage.getItem('hasViewedDiploma');
  if (hasViewedDiploma) return null;

  localStorage.setItem('hasViewedDiploma', true);
  setTimeout(() => {
    document.getElementById('showDiplomaButton').click();
  }, 2000);

  return null;
};

export default class TrainingView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      totalProgressValue: 0,
      diploma: 0,
      firstName: 'Firstname',
      lastName: 'Lastname',
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.getUserInfo();
  }

  componentDidUpdate() {
    const { diploma, totalProgressValue } = this.state;
    if (totalProgressValue >= 100 && diploma !== 100) {
      this.setState({ diploma: 100 });
    }

    if (diploma >= 100) {
      const d = new Date(Date.now());
      const leading = val => `0${val}`.slice(-2);
      StorageHandler.load(storageKeys.user).then((user) => {
        if (user && user.response && user.response.training_graduated === null) {
          const obj = user;
          const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;
          DataHandler.matchAppId().then((appId) => {
            APIHandler.updateSfUser(appId, obj.response.email, [
              { param: 'sales_companion_registered', val: date },
              { param: 'training_started', val: date },
              { param: 'training_graduated', val: date },
              { param: 'progress', val: 100 },
            ]).then((res) => {});
            APIHandler.updateUser(appId, obj.response.email, [
              { param: 'sales_companion_registered', val: date },
              { param: 'training_started', val: date },
              { param: 'training_graduated', val: date },
            ]).then((res) => {
              if (res) {
                obj.response.sales_companion_registered = date;
                obj.response.training_started = date;
                obj.response.training_graduated = date;
                StorageHandler.save(storageKeys.user, obj);
              }
            });
          });
        }
      });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getUserInfo() {
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        const { email } = res;
        DataHandler.matchAppId().then((appId) => {
          APIHandler.getUserProgress(appId, email).then((userProgress) => {
            const totalProgress = getTotalProgress(userProgress);
            const totalPages = getTotalPages(userProgress);
            const percentage = calculateProgress(totalProgress, totalPages);
            this.setState({
              totalProgressValue: percentage >= 100 ? 100 : percentage,
            });
            this.updateSf(percentage >= 100 ? 100 : percentage);

            if (percentage >= 100) {
              this.setState({ diploma: 100 });
            } else {
              this.setState({ diploma: 0 });
            }
          });
          StorageHandler.load(storageKeys.user).then((user) => {
            if (user) {
              const {
                first_name: firstName,
                last_name: lastName,
              } = user;
              this.setState({ firstName, lastName, appId });
            }
          });
        });
      } else {
        this.setState({ totalProgressValue: 0 });
      }
    });
  }

  updateSf(progress) {
    if (progress >= 100) {
      this.setState({ diploma: 100 });
    } else {
      this.setState({ diploma: 0 });
    }

    if (progress >= 100) {
      StorageHandler.load(storageKeys.user).then((user) => {
        DataHandler.matchAppId().then((appId) => {
          const obj = user;
          const d = new Date(Date.now());
          const leading = val => `0${val}`.slice(-2);
          const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;
          APIHandler.updateUser(appId, obj.email, [
            { param: 'sales_companion_registered', val: date },
            { param: 'training_started', val: date },
            { param: 'training_graduated', val: date },
            { param: 'progress', val: 100 },
          ]).then((res) => {});
        });
      });
    } else {
      StorageHandler.load(storageKeys.user).then((user) => {
        DataHandler.matchAppId().then((appId) => {
          const obj = user;
          APIHandler.updateUser(appId, obj.email, [
            { param: 'progress', val: progress },
          ]).then((res) => {});
        });
      });
    }
  }

  render() {
    const {
      diploma,
      firstName,
      lastName,
      appId,
      totalProgressValue,
    } = this.state;

    return (
      <div className="trainingOverview">
        <BackButton to="/main" useHistory={false} />
        <div className="contentContainer trainingView">
          <ContentHeader
            header={i18n.translate('contentHeaders.train')}
            subtitle={i18n.translate('pageDescriptions.train')}
            line={false}
          >
           <div className="container__Progress">
              <div className="container__progressBar">
                <Progress id="progress" value={totalProgressValue} />
                {totalProgressValue > 0 && <h6 className="progressText">{`${totalProgressValue}% Complete`}</h6>}
              </div>
              <a
                id="showDiplomaButton" // id used for simulating click
                className={`container__progressDiploma ${totalProgressValue === 100 ? 'completed' : ''}`}
                role="button"
                tabIndex={-1}
                data-fancybox
                data-src="#diploma"
                data-options='{"toolbar" : "true", "buttons" : ["close"]}'
                href="javascript:;"
                style={{ pointerEvents: (diploma === 100 ? 'auto' : 'none') }}
              >
                <i
                  className={`far fa-file-certificate ${diploma === 100 ? 'completed' : ''}`}
                />
                <span className="text__viewDiploma">View Diploma ></span>
              </a>
            </div>
          </ContentHeader>
          <TrainingGrid />
          <React.Fragment>
            <Diploma appId={appId} firstName={firstName} lastName={lastName} />
            <ViewDiploma diploma={diploma} />
          </React.Fragment>
        </div>
      </div>
    );
  }
}

Diploma.propTypes = {
  appId: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
};

Diploma.defaultProps = {
  firstName: '',
  lastName: '',
};
